export default {"src":"/_next/static/media/pair-4.9d14f407.svg","height":330,"width":340,"blurWidth":0,"blurHeight":0};